import { type Context as ContextV1 } from '../models/ai-request.model';
import { type Context as ContextV3 } from '@bizzdesign/ai-assistant/workflows';

export function mapV1ContextToV3Context(
  context: (ContextV1 | { type: 'userPrompt'; context: string })[],
): ContextV3[] {
  const mapped: ContextV3[] = context.map((item) => {
    if (item.type === 'dataset') {
      return {
        type: 'dataset',
        payload: item.context,
      };
    }
    if (item.type === 'userPrompt') {
      return {
        type: 'userPrompt',
        payload: item.context,
      };
    }
    if (item.type === 'selected-suggestion') {
      if (item.context.type === 'prompt') {
        throw new Error(
          'Unable to map selected-suggestion of type prompt to v3 context',
        );
      }
      return {
        type: 'selected-suggestion',
        payload: item.context.id,
      };
    }
    if (item.type === 'visualization') {
      return {
        type: 'visualization-configuration',
        payload: item.context.configuration,
      };
    }
    throw new Error(`Unknown context: ${item}`);
  });

  return mapped;
}
